'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    border-radius: ', ';\n    border: 1px solid ', ';\n    margin-top: 20px;\n\n    &:last-child {\n        margin-bottom: 20px;\n    }\n\n    & > button {\n        width: 100%;\n    }\n\n    @media (min-width: ', ') {\n        flex-direction: row;\n        justify-content: space-between;\n\n        & > button {\n            width: auto;\n        }\n    }\n'], ['\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    border-radius: ', ';\n    border: 1px solid ', ';\n    margin-top: 20px;\n\n    &:last-child {\n        margin-bottom: 20px;\n    }\n\n    & > button {\n        width: 100%;\n    }\n\n    @media (min-width: ', ') {\n        flex-direction: row;\n        justify-content: space-between;\n\n        & > button {\n            width: auto;\n        }\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: .5rem;\n\n    @media (min-width: ', ') {\n        flex-direction: row;\n        margin-bottom: ', ';\n    }\n'], ['\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: .5rem;\n\n    @media (min-width: ', ') {\n        flex-direction: row;\n        margin-bottom: ', ';\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactIntl = require('react-intl');

var _document = require('../../atoms/icons/document');

var _document2 = _interopRequireDefault(_document);

var _colors = require('../../constants/colors');

var _screenSize = require('../../constants/screenSize');

var _sizes = require('../../constants/sizes');

var _radius = require('../../constants/radius');

var _alignments = require('../../constants/alignments');

var _downloadButton = require('../../atoms/buttons/downloadButton');

var _downloadButton2 = _interopRequireDefault(_downloadButton);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DocumentComponent = _styledComponents2.default.div(_templateObject, _radius.Radius.large, _colors.Colors.cello45, _screenSize.ScreenSize.md);

var IconPlusLabelContainer = _styledComponents2.default.div(_templateObject2, _screenSize.ScreenSize.md, _sizes.Sizes.none);

var Document = function (_React$Component) {
    _inherits(Document, _React$Component);

    function Document() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Document);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Document.__proto__ || Object.getPrototypeOf(Document)).call.apply(_ref, [this].concat(args))), _this), _this.handleDownload = function () {
            return _this.props.downloadEvent(_this.props.document.guid);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Document, [{
        key: 'render',
        value: function render() {
            var document = this.props.document;

            return _react2.default.createElement(
                DocumentComponent,
                null,
                _react2.default.createElement(
                    IconPlusLabelContainer,
                    null,
                    _react2.default.createElement(_document2.default, { left: _sizes.Sizes.md,
                        right: _sizes.Sizes.md
                    }),
                    _react2.default.createElement(_label2.default, { text: document.displayName,
                        textAlign: _alignments.Alignments.left
                    })
                ),
                _react2.default.createElement(_downloadButton2.default, { clickEvent: this.handleDownload,
                    text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Document.download' })
                })
            );
        }
    }]);

    return Document;
}(_react2.default.Component);

exports.default = Document;